import { chain, replace } from 'lodash';

export default function(url) {
  try {
    const searchParams = new URL(url).searchParams;
    const urlParams = {};
    for (let pair of searchParams.entries()) {
      urlParams[pair[0]] = pair[1];
    }
    return urlParams;
  } catch (e) {
    return chain(replace(url, /^.*?\?/, '').split('&'))
      .map(function(p) { return p.split('='); })
      .forEach(function(p) { p[1] = decodeURIComponent(p[1]).replace(/\+/g, ' '); })
      .fromPairs()
      .value();
  }
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/helpers/parse-url-params.js
 **/